



































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { OrderEntity } from "@/model/Order";
import { HotelPolicyEntity, HotelProductEntity } from "@/model/hotel";
import * as _ from "lodash";
import orderInfo from "../orderInfo";
import hotelService from "@/service/hotelService";
import { Overlay, Step, Steps, Dialog } from "vant";
import { ApplyArea, BookingType, BusinessType, DealStatus, PriceType } from "@/model/Base";
import moment from "moment";

@Component({
  name: "hotelOrderInfo",
  components: {
    [Overlay.name]: Overlay,
    [Step.name]: Step,
    [Steps.name]: Steps,
  },
})
export default class HotelOrderInfo extends orderInfo {
  @Prop()
  InsurancePrice?: any;

  @Prop()
  ChargePrice?: any;

  service = hotelService;
  showRule = false;
  isShowPdtInfo = false;
  isShowPriceInfo = false;

  get canRefund() {
    return moment(this.order.FinishedDate).isAfter(moment());
  }
  get isRebookingActive() {
    const __self = this;
    if (__self.order.BusinessType != BusinessType.Sales || __self.order.CreateUserID != __self.profile.UserID) {
      return false;
    }
    if (__self.order.ClientOrderStatus == DealStatus.Finished || __self.order.ClientOrderStatus == DealStatus.Canceled) {
      return true;
    }
    return false;
  }
  starParse(starLevel: string) {
    let level = parseInt(starLevel);
    if (level) {
      return level;
    }
    return 0;
  }

  extractExtra(code: string, order: OrderEntity, product: HotelProductEntity) {
    let extraInfo = _.find(order.ExtraInfos, e => e.ExtraCode == code && e.IncludeID == product.ProductID);
    return (extraInfo && extraInfo.ExtraData) || "";
  }
  showExtra(order: OrderEntity, product: HotelProductEntity) {
    let extraData = "";
    let extraInfo = null;

    extraInfo = _.find(order.ExtraInfos, e => e.ExtraCode == "Hotel.Spec.RoomBedType" && e.IncludeID == product.ProductID);
    if (extraInfo && extraInfo.ExtraData) {
      extraData += extraInfo.ExtraData + " | ";
    }
    extraInfo = _.find(order.ExtraInfos, e => e.ExtraCode == "Hotel.Spec.RoomWindow" && e.IncludeID == product.ProductID);
    if (extraInfo && extraInfo.ExtraData) {
      extraData += extraInfo.ExtraData + " | ";
    }
    extraInfo = _.find(order.ExtraInfos, e => e.ExtraCode == "Hotel.Throw.RoomWindow" && e.IncludeID == product.ProductID);
    if (extraInfo && extraInfo.ExtraData) {
      extraData += extraInfo.ExtraData + " | ";
    }
    extraInfo = _.find(order.ExtraInfos, e => e.ExtraCode == "Hotel.Spec.RoomFloor" && e.IncludeID == product.ProductID);
    if (extraInfo && extraInfo.ExtraData) {
      extraData += "楼层" + extraInfo.ExtraData + " | ";
    }
    extraInfo = _.find(order.ExtraInfos, e => e.ExtraCode == "Hotel.Policy.GoodBreakfast" && e.IncludeID == product.ProductID);
    if (!extraInfo || !extraInfo.ExtraData || extraInfo.ExtraData == "0") {
      extraData += this.$root.$t("order_hotel_hotelorderinfo_wuzao") as string;
    } else if (/^\d+$/.test(extraInfo.ExtraData)) {
      extraData += `早餐${extraInfo.ExtraData}份`
    }
    else {
      extraData += extraInfo.ExtraData;
    }

    return extraData;
  }
  showFacilities(order: OrderEntity, product: HotelProductEntity) {
    var extraInfo = _.find(order.ExtraInfos, e => e.ExtraCode == "Hotel.Product.Facilities" && e.IncludeID == product.ProductID);
    return (extraInfo && extraInfo.ExtraData) || null;
  }
  showRules(BackRule?: string) {
    if (BackRule) {
      this.showRule = true;
    }
  }
  call(phone: number) {
    window.location.href = `tel://${phone}`;
  }

  ToMap(Product: any) {
    let __self = this;
    __self.$router.push({
      path: "/WebMap",
      query: {
        title: Product.ProduceName,
        latitude: Product.ConsumerLatitude,
        longitude: Product.ConsumerLongitude,
      },
    });
  }
  extractProduct(policy: HotelPolicyEntity) {
    return policy.Products![0];
  }
  calcDays(val?: HotelProductEntity) {
    if (val == undefined) {
      val = this.extractProduct(this.order.Policys![0]);
    }
    let Date1 = new Date(moment(val!.ConsumerDate).format("YYYY-MM-DD"));
    let Date2 = new Date(moment(val!.FinishedDate).format("YYYY-MM-DD"));
    let day = Math.abs(Date2.getTime() - Date1.getTime()) / 1000 / 60 / 60 / 24;
    return day;
  }
  calcDayPrice(SalesPrice: number, policy: HotelPolicyEntity) {
    return SalesPrice / this.calcDays(this.extractProduct(policy));
  }

  decoratePrice(Prices?: any, policy?: HotelPolicyEntity) {
    let results: any[] = [];
    let days = this.calcDays(this.extractProduct(policy!));
    // var hotelFare = _.filter(Prices, g => g.PriceType == PriceType.HotelFare).forEach(o => (o.SalesPrice = o.SalesPrice / days));
    _.map(
      _.groupBy(Prices, g => (g.GroupCode ? g.GroupCode : "")),
      o => {
        let result = Object.assign({}, o[0]);
        result.SalesPrice = _.sumBy(o, "SalesPrice");
        results.push(result);
      }
    );
    return results.filter(o => o.SalesPrice != 0).sort((a, b) => a.PriceType - b.PriceType);
  }
  Rebooking() {
    var product = (this.order as any).Policys[0].Products[0];
    this.gotoHotelDetails(product);
  }
  gotoHotelDetails(product: HotelProductEntity) {
    let departDate = moment(product.FinishedDate);
    if (moment(departDate).isBefore(moment())) {
      departDate = moment();
    }

    let departDateStr = departDate.format("YYYY-MM-DD");
    let arriveDateStr = departDate.add(1, "days").format("YYYY-MM-DD");
    /**
      http://lcsl.ecsweb.net:8380/mall/hotel/details
      ?ShoppingID=9C370CDCC7A14B23B6B00CABBE77D7FA
      &ProductId=E5FBC18998FA495998CF8238DDBCCE5F
      &ApplyArea=1126
      &BookingType=1529
      &ServiceType=HotelService
      &FeatureCodes=None
      &Wheres=%5B%7B%22ZoneId%22%3A%2211181%22,%22ConsumerDate%22%3A%222021-06-15%22,%22FinishedDate%22%3A%222021-06-16%22%7D%5D
      &Consumers=%5B%7B%22ConsumerID%22%3A%22S00008447832%22,%22ConsumerName%22%3A%22%E6%B5%8B%E8%AF%95123%22%7D%5D
      &CityCode=SHA
      &DepartDate=2021-06-15
      &ArriveDate=2021-06-16
      */
    var consumers = this.order.Consumers?.map(o => {
      return { ConsumerID: o.UserID, ConsumerName: o.ConsumerName };
    });
    let cid = this.extractExtra("Hotel.Product.CID", this.order, product);
    let hotelId = this.extractExtra("Hotel.Product.HotelId", this.order, product);
    if (!cid || !hotelId) {
      return Dialog.alert({ message: "协议酒店不支持再次预定，请在酒店预订首页重新预定，感谢支持！" })
    }
    const queryData: any = {
      ShoppingID: "shop" + new Date().getTime(),
      // ProductId: product.SourceID,
      ApplyArea: ApplyArea.Internal,
      BookingType: BookingType.OnBusiness,
      ServiceType: "HotelService",
      FeatureCodes: "",
      Wheres: JSON.stringify([
        {
          ConsumerDate: departDateStr,
          FinishedDate: arriveDateStr,
        },
      ]),
      Consumers: JSON.stringify(consumers),
      CityCode: product.ConsumerZoneCode || product.ConsumerCityCode,
      DepartDate: departDateStr,
      ArriveDate: arriveDateStr,
      cid: cid,
      hotelId: hotelId,
    };
    this.$router.push({
      path: "/mall/hotel/details",
      query: queryData,
    });
  }
}
